export default "__VITE_ASSET__35757a6a__"